import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2.5, 0),
  },
  tableItem: {
    borderLeft: `${theme.spacing(1)} solid`,
    '&:first-child': {
      borderTopLeftRadius: theme.spacing(1),
    },
    '&:last-child': {
      borderLeft: `${theme.spacing(1)} solid `,
      borderBottomLeftRadius: theme.spacing(1),
    },
  },
}));

export default useStyles;
